export default "__VITE_ASSET__dUEMnrWB__"